// ChartDrawer.js
import React from 'react';
import './css/ChartDrawer.css'; // You'll define animation here
import StockChart from './StockChart';
import StockCandlestickChart from './StockCandlestickChart';

const ChartDrawer = ({ visible, token, symbol, onClose }) => {
    if (!visible) return null;

    return (
        <div className="chart-drawer">
            <button className="close-btn" onClick={onClose}>✕</button>
            <h3>{symbol}</h3>
            {/* Add tabs to switch chart types */}
            <StockChart token={token} />
            {/* <StockCandlestickChart symbol={symbol} /> */}
        </div>
    );
};

export default ChartDrawer;
